export default {
  "common": {
    "accessManagement": "Gestión de Acceso",
    "action": "Acción",
    "actions": "Acciones",
    "activate": "Reactivar",
    "activate_field": "Reactivar campo",
    "activate_field_confirmation": "El campo volverá a mostrarse en el constructor, la exportación y la importación.",
    "activate_link": "Activar enlace",
    "active": "Activo",
    "add_as_role": "Agregar como {{role}} ({{quantity}})",
    "add_column": "Agregar columna",
    "add_dependency": "Agregar dependencia",
    "add_field": "Agregar campo",
    "add_group": "Agregar Grupo",
    "add_group_feature_description": "Seleccione el grupo que desea agregar a la funcionalidad",
    "add_group_feature_title": "Agregar grupo a la funcionalidad",
    "add_initiative": "Agregar iniciativa",
    "add_one_option_per_line": "Agregar una opción por línea",
    "add_option": "Agregar opción",
    "add_permission": "Agregar permiso",
    "add_question": "Agregar pregunta",
    "add_related_field": "Agregar campo relacionado",
    "add_row": "Agregar fila",
    "add_rule": "Agregar regla",
    "add_section": "Agregar sección",
    "add_to_group": "Agregar a un grupo",
    "add_user": "Agregar Usuario",
    "add_user_feature_description": "Seleccione el usuario que desea agregar a la funcionalidad",
    "add_user_feature_title": "Agregar usuario a la funcionalidad",
    "add_user_to_group": "Agregar usuario al grupo",
    "add_users_to_initiative": "Agregar usuarios a la iniciativa",
    "add_workflow": "Agregar Workflow",
    "added_at": "Agregado el",
    "administrator": "Administrador",
    "administrator_role_description": "Acceso completo a la iniciativa: configuración, funcionalidades, recolecciones, importaciones y exportaciones.",
    "alias": "Alias",
    "alias_format": "El alias debe comenzar con una letra minúscula o un guion bajo y contener solo letras minúsculas, números o guiones bajos",
    "alias_invalid_others_suffix": "El alias no puede terminar con \"_others\"",
    "alias_invalid_reserved_word": "Alias no válido. No puede ser una palabra reservada.",
    "alias_max_length": "El alias debe tener como máximo 100 caracteres",
    "alias_min_length": "El alias debe tener como mínimo 3 caracteres",
    "all": "Todas",
    "all_done": "¡Todo listo, gracias!",
    "all_relations": "Todas",
    "allow_others": "Agregar otros?",
    "allow_typed_signature": "¿Permitir firma escrita?",
    "already_has_permission": "ya tiene permiso: {{role}}",
    "and": "Y",
    "annex_from_device": "Cargar del dispositivo",
    "anom_user": "Anónimo",
    "apply_filter": "Aplicar",
    "apply_filter_count_one": "Aplicar ({{count}})",
    "apply_filter_count_many": "Aplicar ({{count}})",
    "apply_filter_count_other": "Aplicar ({{count}})",
    "apply_rules": "Aplicar reglas",
    "ascending_relations": "Ascendentes",
    "attributes": "Atributos",
    "audio_duration": "Duración del audio",
    "audio_input_accepted_formats": "MP3, WAV, M4A u OGG · máx. 10MB",
    "audio_input_delete_confirm_message": "Esta grabación se eliminará de forma permanente. ¿Deseas continuar?",
    "audio_input_delete_confirm_title": "¿Eliminar grabación?",
    "audio_input_discard_confirm_message": "La grabación actual se perderá. ¿Deseas continuar?",
    "audio_input_discard_confirm_title": "¿Descartar grabación?",
    "audio_recording_too_long": "La grabación terminaba automáticamente en {{segundos}} segundos",
    "audio_recording_too_short": "La grabación debe tener al menos {{seconds}} segundos",
    "audio_uploading_helper_text": "Enviando audio... no cierres el formulario.",
    "audio_uploading_step_label": "Enviando",
    "authentication": "Autentificación",
    "back": "Volver",
    "back_to_feature": "Volver a la Funcionalidad",
    "back_to_home": "Volver al inicio",
    "back_to_initiative": "Volver a la iniciativa",
    "batch_limit_reached": "Límite de {{max}} usuarios a la vez alcanzado.",
    "begins_with": "Comienza con",
    "between": "Entre",
    "both_filters_cannot_be_empty": "Ambos filtros no pueden estar vacíos",
    "building": "En construcción...",
    "business": "Negocio",
    "business_created_successfully": "Negocio creado con éxito.",
    "business_data": "Datos del negocio",
    "business_name": "Nombre del negocio",
    "business_required": "El negocio es obligatorio",
    "business_updated_successfully": "Negocio actualizado con éxito.",
    "businesses": "Negocios",
    "businesses_count_one": " · {{count}} negocio",
    "businesses_count_many": " · {{count}} negocios",
    "businesses_count_other": " · {{count}} negocios",
    "cancel": "Cancelar",
    "cannot_change_own_permission": "No es posible cambiar tu propio permiso",
    "cannot_delete_group_with_users": "No puede eliminar el grupo porque tiene usuarios",
    "cannot_remove_last_section": "No se puede eliminar la última sección",
    "cannot_save_empty_filter": "No se puede guardar un filtro vacío",
    "cannot_save_empty_form": "No se puede guardar formulario vacío",
    "carousel_go_to_item": "Ir al elemento {{index}}",
    "change_password": "Cambiar contraseña",
    "change_permission": "Cambiar permiso",
    "change_user_password": "Cambiar contraseña del usuario",
    "change_user_password_description": "Cree una contraseña temporal para el usuario, que deberá ser cambiada en el próximo inicio de sesión.",
    "choose_an_attribute_from_the_list_above": "Elija un campo de la lista de arriba",
    "choose_field_from_table": "Elija un campo de la tabla de datos",
    "choose_layout_link": "Seleccione el diseño para el que desea crear el enlace:",
    "clean_unsaved_collect": "Limpiar recolección no guardada",
    "clear_filter": "Limpiar",
    "click_here_to_view": "Abrir o descargar en nueva pestaña",
    "CNPJ_invalid": "El CNPJ informado es inválido.",
    "CNPJ_max_length_18": "El CNPJ debe tener como máximo 18 caracteres.",
    "CNPJ_min_length_18": "El CNPJ debe tener como mínimo 18 caracteres.",
    "CNPJ_required": "El CNPJ es obligatorio",
    "code_editor_collapsed_image": "imagen · {{size}} KB",
    "collapse_all": "Contraer todo",
    "collect": "Recolección",
    "collect_already_registered": "Recolección ya registrada.",
    "collect_back_button": "Anterior",
    "collect_concluded_button": "Concluir formulario",
    "collect_created_confirmation": "¿Desea volver al listado o crear una nueva colecta?",
    "collect_created_title": "Colecta guardada con éxito",
    "collect_date_time": "{{date}} a las {{hours}}:{{minutes}}",
    "collect_days_ago_one": "hace {{count}} día",
    "collect_days_ago_many": "hace {{count}} días",
    "collect_days_ago_other": "hace {{count}} días",
    "collect_delete_in_use_description": "Esta recolección no puede eliminarse porque está siendo utilizada en otra funcionalidad.",
    "collect_delete_in_use_title": "Recolección en uso",
    "collect_hours_ago_one": "hace {{count}} hora",
    "collect_hours_ago_many": "hace {{count}} horas",
    "collect_hours_ago_other": "hace {{count}} horas",
    "collect_just_now": "Ahora",
    "collect_minutes_ago_one": "hace {{count}} minuto",
    "collect_minutes_ago_many": "hace {{count}} minutos",
    "collect_minutes_ago_other": "hace {{count}} minutos",
    "collect_months_ago_one": "hace {{count}} mes",
    "collect_months_ago_many": "hace {{count}} meses",
    "collect_months_ago_other": "hace {{count}} meses",
    "collect_next_button": "Próxima sección",
    "collect_section_paginate": "Sección",
    "collect_section_paginate_separator": "de",
    "collect_versions": "Versiones de recolección",
    "collect_years_ago_one": "hace {{count}} año",
    "collect_years_ago_many": "hace {{count}} años",
    "collect_years_ago_other": "hace {{count}} años",
    "collect(s)": "Recolección(es)",
    "collected_by": "Recolectado por {{name}}",
    "collects": "Recolecciones",
    "collects_count_one": "{{count}} colecta",
    "collects_count_many": "{{count}} colectas",
    "collects_count_other": "{{count}} colectas",
    "collects_label_one": "colecta",
    "collects_label_many": "colectas",
    "collects_label_other": "colectas",
    "collects_last_7_days": "Recopilaciones 7d",
    "collects_point_to_this_one": "{{count}} colecta apunta a esta",
    "collects_point_to_this_many": "{{count}} colectas apuntan a esta",
    "collects_point_to_this_other": "{{count}} colectas apuntan a esta",
    "column_size": "Tamaño de la columna",
    "condition": "Condición",
    "condition_contains": "Contiene",
    "condition_equal": "Igual",
    "condition_greater_than": "Mayor que",
    "condition_less_than": "Menor que",
    "condition_multiple": "Múltiple",
    "configurations": "Configuraciones",
    "configure": "Configurar",
    "configure_attribute": "Configurar atributo",
    "confirm": "Confirmar",
    "confirm_action": "Confirmar cambio de estado",
    "confirm_change_to_administrator": "El acceso de {{name}} se ampliará: pasará a administrar la iniciativa, con acceso a la configuración, las funcionalidades y las recolecciones.",
    "confirm_change_to_dashboard": "{{name}} perderá el acceso a la configuración de la iniciativa, a las funcionalidades y a las recolecciones, excepto por los perfiles que tenga directamente en funcionalidades.",
    "confirm_delete_feature": "¿Está seguro de que desea eliminar esta funcionalidad?",
    "confirm_password": "Confirme la contraseña",
    "confirm_remove_dependencies_description": "Al cambiar este campo, las dependencias actuales serán eliminadas. ¿Está seguro de que desea continuar?",
    "confirm_remove_permission": "¿Quitar el permiso de {{name}} en esta iniciativa?",
    "confirm_remove_row_description": "¿Desea realmente eliminar esta línea? Los campos contenidos en ella serán eliminados.",
    "confirm_remove_section_description": "¿Desea realmente eliminar esta sección? Los campos que contiene serán eliminados.",
    "confirm_update_field_in_published_layout": "¿Desea realmente actualizar este campo?",
    "connect_question": "Conectar pregunta",
    "consent_text_min_length": "El texto de consentimiento debe tener como mínimo 5 caracteres.",
    "consent_text_required": "Es necesario informar el texto de consentimiento",
    "contact_initiative_administrator": "Contacta al administrador de la iniciativa.",
    "contains": "Contiene",
    "contains_file": "Contiene archivo",
    "copy_default_view": "Copiar visualización predeterminada",
    "CPF_invalid": "El CPF informado es inválido.",
    "CPF_min_length_11": "El CPF debe tener al menos 11 caracteres.",
    "create": "Crear",
    "create_business": "Crear Negocio",
    "create_field": "Crear campo",
    "create_group": "Crear grupo",
    "create_initiative": "Crear iniciativa",
    "create_new_collect": "Crear nueva colecta",
    "create_user": "Crear usuario",
    "created_at": "Creado el",
    "created_at_label": "Creado {{date}}",
    "created_by": "Creado por",
    "created_with": "Formulario creado con",
    "currency_symbol": "$",
    "custom_fields": "Campos personalizados",
    "customize_layout_attributes": "Personalizar diseño y atributos",
    "dashboard": "Dashboard",
    "dashboard_link": "Enlace del dashboard",
    "dashboard_link_placeholder": "https://app.powerbi.com/ejemplo",
    "dashboard_only_access_badge": "Acceso solo a los paneles analíticos",
    "dashboard_only_card_badge": "Solo dashboard — Acceso a los paneles analíticos",
    "dashboard_role_description": "Acceso solo a los paneles analíticos (Power BI). No accede a funcionalidades, recolecciones, archivos, mapa de datos, importaciones ni exportaciones.",
    "data_collection": "Recolección de datos",
    "data_information": "Datos e información",
    "data_map": "Mapa de datos",
    "data_source": "Fuente de datos",
    "data_table": "Tabla de datos",
    "date_invalid": "La fecha debe estar en formato dd/mm/aaaa",
    "DateTime_invalid": "La fecha y hora deben estar en formato dd/mm/aaaa HH:mm",
    "deactivate": "Inactivar",
    "deactivate_field": "Inactivar campo",
    "deactivate_field_confirmation": "El campo dejará de aparecer en el constructor, la exportación y la importación, pero se mantiene el historial de las recolecciones.",
    "deactivate_link": "Desactivar enlace",
    "default_view": "Visualización predeterminada",
    "define_super_admin_permissions": "Definir permisos de super admin",
    "delete": "Eliminar",
    "delete_attribute": "Eliminar atributo",
    "delete_collect": "¿Realmente desea eliminar esta colecta?",
    "delete_dependency": "Eliminar dependencia",
    "delete_feature": "Eliminar Funcionalidad",
    "delete_feature_confirmation_label": "Sí, entiendo y quiero eliminar esta funcionalidad",
    "delete_feature_warning": "Atención: Esta acción es irreversible. Todos los datos vinculados a esta funcionalidad se eliminarán permanentemente.",
    "delete_initiative": "Eliminar iniciativa",
    "delete_initiative_confirmation": "¿Desea realmente excluir esta iniciativa?",
    "delete_option": "Eliminar opción",
    "delete_permission": "Eliminar permiso",
    "delete_permission_confirmation": "¿Desea realmente eliminar este permiso?",
    "delete_workflow": "Eliminar workflow",
    "delete_workflow_description": "¿Está seguro de que desea eliminar este workflow?",
    "dependencies": "Dependencias",
    "dependencies_count_one": "dependencia ({{count}})",
    "dependencies_count_many": "dependencias ({{count}})",
    "dependencies_count_other": "dependencias ({{count}})",
    "descending_relations": "Descendentes",
    "description": "Descripción",
    "description_length_invalid": "La descripción debe tener al menos 1 carácter.",
    "description_max_length": "La descripción debe tener como máximo 5000 caracteres.",
    "Description_max_length_3_800": "La descripción debe tener entre 3 y 800 caracteres",
    "description_min_length": "La descripción debe tener al menos 1 carácter.",
    "description_min_length_3_800": "La descripción debe tener al menos 3 caracteres y como máximo 800 caracteres.",
    "description_required": "La descripción es obligatoria.",
    "destination_initiative_required": "Debe seleccionar una iniciativa de destino para duplicar.",
    "destination_required": "El destino es obligatorio",
    "disable_portfolio": "Deshabilitar portafolio",
    "discard": "Descartar",
    "do_you_really_want_to_remove_the_email_template": "¿Realmente desea eliminar esta plantilla de correo electrónico?",
    "do_you_really_want_to_remove_the_group": "¿Desea realmente eliminar el grupo?",
    "download": "Download",
    "download_template": "Descargar plantilla",
    "draft_saved": "Borrador guardado",
    "drag_and_drop_file": "Arrastre y suelte el archivo",
    "drag_to_reorder": "Arrastra para reordenar",
    "duplicate_feature": "Duplicar Funcionalidad",
    "duplicate_initiative": "Duplicar Iniciativa",
    "duplicate_section_title": "Ya existe una sección con este título.",
    "edit": "Edición",
    "edit_and_delete": "Edición y Eliminación",
    "edit_feature": "Editar Funcionalidad",
    "edit_initiative": "Editar iniciativa",
    "edit_portfolio": "Editar portafolio",
    "edit_user": "Editar usuario",
    "editGroup": "Editar grupo",
    "email": "Correo electrónico",
    "email_body": "Cuerpo del correo",
    "email_invalid": "El email no es válido",
    "email_required": "El email es obligatorio",
    "email_template_body": "Cuerpo del correo (HTML)",
    "email_template_body_required": "El cuerpo del correo es obligatorio",
    "email_template_code": "Código",
    "email_template_compatibility_warning": "Algunos atributos y recursos de HTML/CSS pueden no funcionar en todos los clientes de correo.",
    "email_template_create": "Nueva plantilla",
    "email_template_created_successfully": "Plantilla de correo creada con éxito",
    "email_template_data": "Datos de la plantilla de correo",
    "email_template_deleted_successfully": "Plantilla de correo eliminada con éxito",
    "email_template_edit": "Editar plantilla",
    "email_template_edited_successfully": "Plantilla de correo actualizada con éxito",
    "email_template_locale": "Idioma",
    "email_template_locale_placeholder": "Seleccione el idioma",
    "email_template_locale_required": "El idioma es obligatorio",
    "email_template_missing_variables": "Faltan variables obligatorias: {{variables}}",
    "email_template_preview": "Vista previa",
    "email_template_preview_empty": "Complete el cuerpo del correo para previsualizarlo",
    "email_template_preview_feature_example": "Funcionalidad de ejemplo",
    "email_template_subject": "Asunto",
    "email_template_subject_max_length": "El asunto debe tener como máximo {{maxLength}} caracteres",
    "email_template_subject_required": "El asunto es obligatorio",
    "email_template_unknown_variables": "Variables no permitidas: {{variables}}",
    "email_template_updated_at": "Actualizado el",
    "email_template_variable_optional": "Variable opcional",
    "email_template_variable_required_missing": "Variable obligatoria ausente",
    "email_template_variable_required_present": "Variable obligatoria presente",
    "email_template_variables": "Variables:",
    "email_templates": "Plantillas de correo",
    "email_templates_description": "Plantillas de correo utilizadas por los workflows de esta iniciativa.",
    "empty_layout": "Diseño vacío",
    "empty_section_title": "El título de la sección no puede ser vacío",
    "enable_portfolio": "Habilitar portafolio",
    "enabled_required": "Es necesario indicar si el usuario está activo",
    "end": "Fin",
    "end_date": "Fecha de fin",
    "ends_with": "Termina con",
    "enter_email": "Ingrese el correo electrónico",
    "enter_email_body": "Ingrese el cuerpo del correo",
    "enter_field_description": "Ingrese una descripción para el campo",
    "enter_field_name": "Ingrese el nombre del campo",
    "enter_new_password": "Ingrese la nueva contraseña",
    "enter_option_name": "Ingrese el nombre de la opción",
    "equals": "Es igual a",
    "error": "Error",
    "exampleEmail {{verb}} {{feature}}": "El siguiente correo electrónico ya se envía de forma predeterminada, lo que escribas en este campo se enviará al final de este mensaje:\nSe ha {{verb}} una recolección con el ID # para la funcionalidad {{feature}}.",
    "executed_at": "Ejecutado el",
    "existing_permissions_hint": "Quien ya tiene permiso en la iniciativa aparece deshabilitado. Para cambiar el permiso, usa la tabla.",
    "exit": "Salir",
    "expand_all": "Expandir todo",
    "export_ascending_relations": "Relaciones ascendentes",
    "export_data": "Exportación de datos",
    "export_data_success": "Solicitud de exportación realizada con éxito.",
    "export_descending_relations": "Relaciones descendentes",
    "export_files": "Exportar archivos de recolecciones",
    "export_pdf": "Exportar PDF",
    "exports": "Exportaciones",
    "feature": "Funcionalidad",
    "feature_created_successfully": "Funcionalidad creada con éxito.",
    "feature_data": "Datos de la Funcionalidad",
    "feature_enabled": "Funcionalidad Activa",
    "feature_name": "Nombre de la Funcionalidad",
    "feature_published": "Funcionalidad publicada",
    "feature_updated_error": "Error al actualizar la funcionalidad",
    "feature_updated_success": "Funcionalidad actualizada con éxito.",
    "features": "Funcionalidades",
    "field": "Campo",
    "field_activated_successfully": "Campo reactivado con éxito.",
    "field_created_successfully": "Campo creado con éxito.",
    "field_deactivated_successfully": "Campo inactivado con éxito.",
    "field_description_max_length": "La descripción debe tener como máximo 5000 caracteres.",
    "field_name_max_length": "El nombre del campo debe tener como máximo 250 caracteres.",
    "field_placeholder": "Campo...",
    "field_required": "El campo es obligatorio",
    "field_type_BIG_INT": "Número entero",
    "field_type_DATE": "Fecha",
    "field_type_DATETIME": "Fecha y hora",
    "field_type_DECIMAL": "Número decimal",
    "field_type_FILE": "Archivo",
    "field_type_GEOGRAPHICAL_MULTIPLE_POINT": "Múltiples puntos geográficos",
    "field_type_GEOGRAPHICAL_POINT": "Punto geográfico",
    "field_type_GEOGRAPHICAL_POLYGON": "Polígono geográfico",
    "field_type_GEOGRAPHICAL_ROUTE": "Ruta geográfica",
    "field_type_IMPORT_FIELD": "Importar una funcionalidad",
    "field_type_INFO_TEXT": "Texto informativo",
    "field_type_LONG_TEXT": "Texto largo",
    "field_type_MATRIZ": "Matriz",
    "field_type_MULTIPLE_LIST": "Caja de selección múltiple",
    "field_type_required": "Es necesario informar el tipo de campo",
    "field_type_TERM": "Término de consentimiento",
    "field_type_TEXT": "Texto corto",
    "field_type_TIME": "Hora",
    "field_type_UNIQUE_LIST": "Caja de selección única",
    "field_updated_successfully": "Campo actualizado con éxito.",
    "fields_filter_active": "Activos",
    "fields_filter_all": "Todos",
    "fields_filter_inactive": "Inactivos",
    "fields_to_export": "Campos a exportar",
    "file": "Archivo",
    "file_cannot_be_null_select_file": "El archivo no puede ser nulo. Por favor, seleccione un archivo para enviar.",
    "file_name": "Nombre del archivo",
    "file_preview_not_supported": "No es posible visualizar el archivo",
    "file_too_large": "Archivo demasiado grande para enviar.",
    "filter_business": "Filtrar por negocio",
    "filter_by_feature": "Filtrar por Funcionalidad",
    "finish": "Finalizar",
    "finished_count": "Finalizadas",
    "finished_rate": "Tasa de Finalización",
    "form_answered_successfully": "Tu respuesta al formulario <b>{{featureName}}</b> fue enviada con éxito y ya está registrada.",
    "full_screen": "Pantalla completa",
    "generate_autoapply": "Generar Autoaplicación",
    "generate_link": "Generar enlace",
    "generated_automatically": "Generado automáticamente",
    "go_to_collects_list": "Volver al listado",
    "go_to_decisio": "Ir a Decisio",
    "go_to_initiative_dashboard": "Ir al panel de la iniciativa",
    "greater_than_or_equal_to": "Mayor o igual a",
    "group": "Grupo",
    "group_added_successfully": "Grupo agregado con éxito.",
    "group_created_successfully": "Grupo creado con éxito.",
    "group_data": "Datos del grupo",
    "group_deleted_successfully": "Grupo eliminado con éxito.",
    "group_edited_successfully": "Grupo editado con éxito.",
    "group_name": "Nombre del grupo",
    "group_required": "El grupo es obligatorio",
    "groups": "Grupos",
    "if_the_answer_is": "Si la respuesta es",
    "image_exceeded_size_limit": "La imagen ha superado el límite de tamaño de {{size}}mb.",
    "image_gallery": "Galería de Imágenes",
    "import_data_success": "Importación de datos realizada con éxito.",
    "import_file": "Archivo de importación",
    "import_finish": "Concluir",
    "import_line_max_length": "Las líneas deben tener un máximo de 255 caracteres.",
    "import_options": "Importar opciones",
    "imported_data": "Importación de datos",
    "imports": "Importaciones",
    "in_seconds": "En segundos",
    "inactive": "Inactivo",
    "info_text_min_length": "El texto de información debe tener como mínimo 5 carácter.",
    "info_text_required": "El texto de información es obligatorio",
    "initiative": "Iniciativa",
    "initiative_access_removed": "Tu acceso a esta iniciativa fue eliminado",
    "initiative_created_successfully": "Iniciativa creada con éxito.",
    "initiative_deleted_successfully": "Iniciativa excluida con éxito.",
    "initiative_edited_successfully": "Iniciativa editada con éxito.",
    "initiative_features": "Funcionalidades de la iniciativa",
    "initiative_imports_and_exports": "Importaciones y exportaciones",
    "initiative_imports_and_exports_description": "Cargue datos o extraiga las colectas en XLSX.",
    "initiative_name": "Nombre de la iniciativa",
    "initiative_name_max_length": "El nombre de la iniciativa debe tener como máximo 50 caracteres.",
    "initiative_successfully_duplicated": "Iniciativa duplicada con éxito.",
    "initiatives": "Iniciativas",
    "initiatives_count_one": "{{count}} iniciativa",
    "initiatives_count_many": "{{count}} iniciativas",
    "initiatives_count_other": "{{count}} iniciativas",
    "integer_invalid": "El entero es inválido",
    "internal_collect": "Recolección interna",
    "internal_collect_back_to_initiative": "Volver a la iniciativa",
    "internal_collect_conflict_retry": "La configuración fue modificada por otra persona. Revísela e inténtelo de nuevo.",
    "internal_collect_feature": "Funcionalidad de la recolección interna",
    "internal_collect_no_access": "No tiene acceso a la recolección interna de esta iniciativa.",
    "internal_collect_no_eligible_features": "Ninguna funcionalidad elegible: debe estar habilitada y con el layout Web publicado.",
    "internal_collect_saved": "Recolección interna guardada con éxito.",
    "internal_collect_sent": "Recolección enviada con éxito.",
    "internal_collect_unavailable": "Recolección interna no disponible.",
    "invalid_email": "Correo electrónico inválido",
    "invalid_option": "Opción inválida",
    "language_en": "Inglés",
    "language_es": "Español",
    "language_pt_br": "Portugués (Brasil)",
    "last_collect": "Última recopilación",
    "last_collects": "Últimas recopilaciones",
    "last_collects_load_error": "No se pudieron cargar las últimas recopilaciones",
    "layout_saved_successfully": "Layout guardado con éxito.",
    "less_than_or_equal_to": "Menor o igual a",
    "like_required": "El término de búsqueda es obligatorio",
    "link": "Vincular",
    "link_collect": "Vincular recolección",
    "link_feature": "Vincular funcionalidad",
    "link_features": "Vincular funcionalidades",
    "link_invalid": "Enlace no válido",
    "linked_features": "Funcionalidades vinculadas",
    "load_more": "Cargar más",
    "load_more_collects_one": "Cargar {{count}} más de {{total}}",
    "load_more_collects_many": "Cargar {{count}} más de {{total}}",
    "load_more_collects_other": "Cargar {{count}} más de {{total}}",
    "load_more_results": "Cargar más resultados",
    "loading_layout": "Cargando diseño...",
    "loading_more": "Cargando...",
    "location": "Localización",
    "logo": "Logo",
    "logo_required": "El logo es obligatorio",
    "lookup": "lookup",
    "main_fields": "Campos principales",
    "main_tab": "Principal",
    "manage_groups_permissions": "Administre los grupos que tienen permisos sobre esta funcionalidad.",
    "manage_users_permissions": "Administre los usuarios que tienen permisos sobre esta funcionalidad.",
    "matrices": "Matrizes",
    "matrix": "Matriz",
    "matrix_fields": "Campos de la matriz",
    "matriz_field": "Campo Matriz",
    "matriz-create": "Crear matriz",
    "matriz-delete": "Eliminar matriz",
    "matriz-update": "Actualizar matriz",
    "max_duration": "Duración máxima",
    "max_duration_cannot_be_greater_than_600": "La duración máxima no puede ser mayor a 600 segundos",
    "maximum_value": "Valor máximo",
    "menu_logout_confirm_description": "Cerrarás la sesión de tu cuenta y cualquier cambio no guardado se perderá. ¿Deseas continuar?",
    "menu_logout_confirm_title": "Salir de Decisio",
    "microphone_access_denied": "Se denegó el acceso al micrófono. Por favor, permita el acceso al micrófono para grabar audio.",
    "min_duration": "Duración mínima",
    "min_value_cannot_be_greater_than_max_value": "El valor mínimo no puede ser mayor que el valor máximo",
    "minimum_value": "Valor mínimo",
    "mobile": "Móvil",
    "monetary_subtype_not_apply_to_text": "El subtipo monetario no se aplica al texto",
    "more_fields_one": "+ {{count}} campo",
    "more_fields_many": "+ {{count}} campos",
    "more_fields_other": "+ {{count}} campos",
    "more_filled_fields_one": "+ {{count}} campo completado",
    "more_filled_fields_many": "+ {{count}} campos completados",
    "more_filled_fields_other": "+ {{count}} campos completados",
    "most_recent": "Más recientes",
    "name": "Nombre",
    "name_max_length": "El nombre debe tener como máximo {{maxLength}} caracteres",
    "name_min_length": "El nombre debe tener al menos 3 caracteres",
    "name_min_length_3": "El nombre debe tener al menos 3 caracteres",
    "name_required": "El nombre es obligatorio",
    "new_collect": "Nueva recolección",
    "new_collect_no_layout": "No hay un diseño publicado y permitido en la funcionalidad de destino",
    "new_export": "Nueva exportación",
    "new_feature": "Nueva funcionalidad",
    "new_import": "Nueva importación",
    "next": "Siguiente",
    "no": "No",
    "no_access_to_area": "No tienes acceso a esta área",
    "no_attribute_selected": "Ningún atributo seleccionado",
    "no_audits_found": "No se encontraron auditorías",
    "no_businesses_found": "No se encontraron negocios",
    "no_collect_found": "No se encontró ninguna recolección",
    "no_collect_links": "No existen enlaces de recolección para esta funcionalidad. Volviendo...",
    "no_collects": "Sin recopilaciones",
    "no_dashboard_available_yet": "Aún no hay ningún panel disponible",
    "no_data_found": "Ningún dato encontrado.",
    "no_email_templates_found": "No se encontraron plantillas de correo.",
    "no_exports_found": "Ninguna exportación encontrada.",
    "no_features_found": "Ninguna funcionalidad encontrada.",
    "no_fields_found": "No se encontraron campos",
    "no_group_permission": "Ningún grupo tiene permiso para esta funcionalidad.",
    "no_groups_found": "No se encontraron grupos",
    "no_imports_found": "Ninguna importación encontrada.",
    "no_initiatives_found": "No se encontraron iniciativas",
    "no_linked_features": "No hay funcionalidades vinculadas",
    "no_permission": "Sin permiso",
    "no_published_layout_redirect": "No hay ningún diseño publicado para esta funcionalidad. Redirigiendo...",
    "no_records_found": "Ningún registro encontrado",
    "no_related_fields_found": "No se encontraron campos relacionados",
    "no_user_permission": "Ningún usuario tiene permiso para esta funcionalidad.",
    "no_users_found": "No se encontraron usuarios",
    "no_workflows_found": "No se encontraron flujos de trabajo",
    "none": "Ninguno",
    "not_authorized": "¡Acceso no autorizado!",
    "not_collect_found": "No se encontraron recolecciones",
    "not_contains": "No contiene",
    "not_equals": "No es igual a",
    "notification": "Notificación",
    "on_change_section": "Al cambiar la matriz de referencia o el tipo de sección, se perderá la configuración actual. ¿Está seguro?",
    "on_close": "Cerrar",
    "only_audio_files": "Solo se permiten archivos de audio",
    "only_images_allowed": "Solo se permiten imágenes",
    "only_images_as_logo": "La empresa solo acepta imágenes de tipo .png, .jpeg, .gif o .webapp como logo.",
    "open": "Abrir",
    "open_collect": "Abrir recolección",
    "open_count": "Aperturas",
    "open_dashboard": "Abrir panel",
    "open_in_power_bi": "Abrir en Power BI",
    "open_initiative": "Abrir iniciativa",
    "operator": "Operador",
    "operator_required": "El operador es obligatorio",
    "option_line_placeholder": "Ingrese una opción por línea",
    "option_name_required": "El nombre de la opción es obligatorio",
    "or": "O",
    "order": "Ordenar",
    "order_by": "Ordenar por",
    "other": "Otros",
    "page_not_found": "Página no encontrada",
    "page_not_found_description": "La página que está buscando no existe.",
    "pagination": "Paginación",
    "participants": "Participantes",
    "password": "Contraseña",
    "password_changed_successfully": "Contraseña cambiada con éxito.",
    "password_max_length": "La contraseña debe tener como máximo 40 caracteres",
    "password_min_length": "La contraseña debe tener al menos 4 caracteres",
    "password_required": "La contraseña es obligatoria",
    "passwords_must_match": "Las contraseñas deben coincidir",
    "past": {
      "create": "creada",
      "delete": "eliminada",
      "update": "actualizada"
    },
    "pause": "Pausar",
    "paused_status": "Pausado",
    "permission": "Permiso",
    "permission_added_success": "Permiso agregado con éxito.",
    "permission_deleted_successfully": "Permiso eliminado con éxito.",
    "permission_removed_successfully": "Permiso eliminado con éxito.",
    "permission_role_changed_successfully": "Permiso cambiado con éxito.",
    "permissions": "Permisos",
    "permissions_added_successfully": "Permisos agregados con éxito ({{quantity}}).",
    "permissions_groups": "Permisos de Grupos",
    "permissions_tab_description": "Gestiona los roles de los usuarios en esta iniciativa.",
    "permissions_user": "Permisos de Usuarios",
    "Phone_max_length_15": "El teléfono debe tener como máximo 15 caracteres",
    "Phone_min_length_14": "El teléfono debe tener al menos 14 caracteres",
    "placeholder_editor": "¡Escriba o pegue su contenido aquí!",
    "platform": "Plataforma",
    "platform_required": "És necesario informar la plataforma",
    "Point_invalid": "El punto es inválido",
    "Point_invalid_range": "El punto está fuera de rango",
    "point_min_length_1": "Debe ser informado pelo menos un punto",
    "portfolio": "Portafolio",
    "positive_invalid": "El número debe ser positivo",
    "power_bi": "Power BI",
    "preview_fields": "Campos de vista previa",
    "previous": "Anterior",
    "processing": "Procesando",
    "publish": "Publicar",
    "recent": "Recientes",
    "record_audio": "Grabar audio",
    "recorded_now": "Grabado ahora",
    "recording_status": "Grabando",
    "region_city_or_neighborhood ": "Región, ciudad o barrio",
    "registration": "Registro",
    "related_field": "Campo relacionado",
    "relationships": "Relaciones",
    "remove": "Eliminar",
    "remove_permission": "Quitar permiso",
    "remove_rule": "Eliminar regla",
    "remove_user": "¿Desea realmente remover el usuario?",
    "remove_user_from_group": "Eliminar usuario del grupo",
    "required_field": "¿Campo obligatorio?",
    "required_matrix": "¿Matriz obligatoria?",
    "response": "Respuesta",
    "response_value": "Valor de la respuesta",
    "responsible_data": "Datos del responsable",
    "responsible_email": "Correo del responsable",
    "Responsible_email_invalid": "El correo del responsable es inválido",
    "Responsible_email_required": "El correo del responsable es obligatorio",
    "responsible_name": "Nombre del responsable",
    "responsible_name_max_length": "El nombre del responsable debe tener como máximo 100 caracteres",
    "Responsible_name_max_length_100": "El nombre del responsable debe tener como máximo 100 caracteres",
    "responsible_name_min_length": "El nombre del responsable debe tener al menos 3 caracteres",
    "Responsible_name_min_length_3": "El nombre del responsable debe tener al menos 3 caracteres",
    "Responsible_name_required": "El nombre del responsable es obligatorio",
    "responsible_phone": "Teléfono del responsable",
    "responsible_phone_max_length": "El teléfono del responsable debe tener como máximo 15 caracteres",
    "Responsible_phone_max_length_15": "El teléfono del responsable debe tener como máximo 15 caracteres",
    "responsible_phone_min_length": "El teléfono del responsable debe tener al menos 14 caracteres",
    "Responsible_phone_min_length_15": "El teléfono del responsable debe tener al menos 14 caracteres",
    "Responsible_phone_required": "El teléfono del responsable es obligatorio",
    "restore_unsaved_collect": "Se ha encontrado una recolección no guardada. ¿Desea restaurarla?",
    "resume": "Reanudar",
    "return_previous_page": "Volver a la página anterior",
    "return_to_businesses_management": "Volver a la gestión de negocios",
    "return_to_destination": "Volver a {{destination}}",
    "return_to_email_templates": "Volver a plantillas de correo",
    "return_to_group_management": "Volver a la gestión de grupos",
    "return_to_initiative": "Volver a la iniciativa",
    "return_to_initiative_management": "Volver a la gestión de iniciativas",
    "return_to_initiatives": "Volver a iniciativas",
    "return_to_initiatives_management": "Volver a la gestión de iniciativas",
    "return_to_user_management": "Volver a la gestión de usuarios",
    "save": "Guardar",
    "save_changes": "Guardar cambios",
    "saved": "Guardado",
    "saving": "Guardando...",
    "search_available_when_loaded": "Búsqueda disponible al terminar",
    "search_businesses": "Buscar negocios",
    "search_by_code_or_label": "Buscar por código o label",
    "search_by_name_or_email": "Buscar por nombre o correo",
    "search_collects": "Buscar recolecciones",
    "search_collects_error": "No se pudieron cargar los resultados de la búsqueda",
    "search_collects_subtitle_one": "Encontradas en {{count}} funcionalidad",
    "search_collects_subtitle_many": "Encontradas en {{count}} funcionalidades",
    "search_collects_subtitle_other": "Encontradas en {{count}} funcionalidades",
    "search_collects_title_one": "{{count}} recolección para “{{search}}”",
    "search_collects_title_many": "{{count}} recolecciones para “{{search}}”",
    "search_collects_title_other": "{{count}} recolecciones para “{{search}}”",
    "search_features": "Buscar Funcionalidades",
    "search_fields": "Buscar campos",
    "search_groups": "Buscar grupos",
    "search_in_initiative": "Buscar en la iniciativa",
    "search_initiative": "Buscar iniciativa",
    "search_min_length": "Escribe al menos {{min}} caracteres para buscar",
    "search_question": "Buscar pregunta",
    "search_users": "Buscar usuarios",
    "second_value_required": "El segundo valor es obligatorio",
    "section": "Sección",
    "section_has_invalid_fields": "La sección tiene campos inválidos.",
    "section_image": "Imagen de la sección",
    "section_order_title": "Sección {{order}}",
    "section_required": "La sección es obligatoria",
    "section_title": "Título de la sección",
    "sections": "Secciones",
    "see_in_collect": "Ver en la recolección",
    "select": "Seleccionar",
    "select_a_feature": "Seleccione una funcionalidad.",
    "select_a_value": "Seleccionar un valor",
    "select_action_type": "Seleccione el tipo de acción",
    "select_all": "Seleccionar todos",
    "select_an_import_file": "Seleccione un archivo de importación.",
    "select_an_option": "Seleccionar una opción",
    "select_at_least_one_item": "Seleccione al menos un item",
    "select_at_least_one_option": "Seleccione al menos una opción",
    "select_attribute": "Seleccionar atributo",
    "select_collect_required": "Es necesario seleccionar una recolección",
    "select_condition": "Seleccione una condición",
    "select_condition_required": "La condición es obligatoria",
    "select_feature": "Seleccione una funcionalidad",
    "select_feature_required": "La funcionalidad es obligatoria",
    "select_features_to_link": "Puedes seleccionar hasta 3 campos de esta funcionalidad para generar una vista previa de la recolección a vincular.",
    "select_field": "Seleccione un campo",
    "select_field_min_options": "El campo de selección debe tener al menos dos opciones.",
    "select_field_subtype": "Seleccione el subtipo",
    "select_field_type": "Seleccione el tipo de campo",
    "select_filters": "Seleccionar filtros",
    "select_group_placeholder": "Seleccione un grupo",
    "select_group_required": "El grupo es obligatorio",
    "select_initiative": "Seleccione una iniciativa",
    "select_initiative_required": "La iniciativa es obligatoria",
    "select_matriz_field": "Seleccione el campo matriz",
    "select_max_three_fields": "Puedes seleccionar hasta 3 campos de esta funcionalidad para generar una vista previa de la recolección a vincular.",
    "select_permission": "Seleccione el permiso",
    "select_permission_level": "Seleccione el nivel de permiso",
    "select_platform_required": "La plataforma es obligatoria",
    "select_preview_fields_tooltip": "Puedes seleccionar hasta 3 campos de esta funcionalidad para generar una vista previa de la recolección a vincular.",
    "select_the_group_you_want_to_add_the_user_to": "Seleccione el grupo al que desea agregar el usuario",
    "select_user": "Seleccione el usuario",
    "select_user_placeholder": "Seleccione un usuario",
    "select_user_required": "El usuario es obligatorio",
    "select_user_to_add_to_group": "Seleccione el usuario que desea agregar al grupo",
    "selected_count_one": "{{count}} seleccionado",
    "selected_count_many": "{{count}} seleccionados",
    "selected_count_other": "{{count}} seleccionados",
    "selected_items": "elementos seleccionados",
    "self_applied_link": "Enlace de autoaplicación",
    "self_applied_session_expired": "Tu sesión ha expirado. Abre el enlace nuevamente e ingresa un nuevo código para continuar.",
    "send_new_answer": "Enviar nueva respuesta",
    "sensitive_data": "Dato sensible",
    "shared_preference": "Cambiar a preferencias personales",
    "show_less": "Mostrar menos",
    "show_more_count_one": "Mostrar {{count}} más",
    "show_more_count_many": "Mostrar {{count}} más",
    "show_more_count_other": "Mostrar {{count}} más",
    "showing_initiatives_one": "Mostrando {{loaded}} de {{count}} iniciativa",
    "showing_initiatives_many": "Mostrando {{loaded}} de {{count}} iniciativas",
    "showing_initiatives_other": "Mostrando {{loaded}} de {{count}} iniciativas",
    "signature_add_title": "Agregar firma",
    "signature_clear": "Limpiar",
    "signature_consent_desktop": "Declaro que esta es mi firma electrónica y acepto usarla para firmar este formulario.",
    "signature_date_label": "Fecha",
    "signature_description": "Firme con el ratón, toque la pantalla o escriba su nombre completo.",
    "signature_description_no_typed": "Firme con el ratón o toque la pantalla.",
    "signature_draw_above_line": "Firme sobre la línea",
    "signature_empty_subtitle": "PNG generado automáticamente y adjuntado a la respuesta",
    "signature_empty_title": "Sin firma registrada",
    "signature_full_name": "Nombre completo",
    "signature_full_name_document_placeholder": "Como aparece en el documento",
    "signature_image_alt": "Firma",
    "signature_location_label": "Ubicación",
    "signature_name_label": "Nombre",
    "signature_name_too_long": "El nombre debe tener como máximo 255 caracteres",
    "signature_name_too_short": "El nombre debe tener al menos 3 letras",
    "signature_redo": "Rehacer",
    "signature_remove": "Eliminar",
    "signature_remove_confirm_message": "Esta firma se eliminará de forma permanente. ¿Deseas continuar?",
    "signature_remove_confirm_title": "¿Eliminar firma?",
    "signature_sample_name": "Su nombre",
    "signature_sign": "Firmar",
    "signature_tab_draw": "Dibujar",
    "signature_tab_type": "Escribir",
    "start": "Inicio",
    "start_date": "Fecha de inicio",
    "start_date_cannot_be_greater_than_end_date": "La fecha de inicio no puede ser mayor que la fecha de fin",
    "start_write_count": "Iniciadas",
    "status": "Estado",
    "status_feature_updated_successfully": "Estado de la funcionalidad {{featureName}} actualizado con éxito",
    "strict_section_navigate": "Navegación estricta entre secciones",
    "sub_type": "Subtipo",
    "subtype_AUDIO": "Audio",
    "subtype_CNPJ": "CNPJ",
    "subtype_CPF": "CPF",
    "subtype_HIPERLINK": "Link",
    "subtype_MAIL": "Correo electrónico",
    "subtype_MONEY_VALUE": "Valor monetario",
    "subtype_PHONE": "Teléfono",
    "subtype_SIGNATURE": "Firma",
    "subtypes_not_apply_to_decimal": "Los subtipos no se aplican a decimal",
    "success": "Success",
    "successfully_duplicated": "Duplicado con éxito",
    "successfully_removed": "Eliminado con éxito",
    "summary_active_collectors": "Recolectores activos",
    "summary_files": "Archivos",
    "summary_files_description": "adjuntos y audios enviados",
    "summary_in_last_7_days": "en los últimos 7 días",
    "summary_last_7_days": "Últimos 7 días",
    "summary_last_collect_at": "última a las {{time}}",
    "summary_no_collects_today": "ninguna recolección hoy",
    "summary_today": "Hoy",
    "summary_total_collects": "Recolecciones totales",
    "summary_vs_previous_month": "{{value}} vs. mes anterior",
    "summary_vs_previous_week": "{{value}} vs. semana anterior",
    "super_admin": "Super administrador",
    "super_admin_business_required": "Indique el nivel de permiso del negocio",
    "super_admin_initiative_required": "Indique el nivel de permiso de la iniciativa",
    "super_admin_permissions": "Permisos de super admin",
    "super_admin_required": "Es necesario indicar si el usuario es super administrador",
    "super_admin_user_required": "Indique el nivel de permiso del usuario",
    "sync_explanation": "Al sincronizar, reemplazas tus preferencias actuales por las preferencias predeterminadas.",
    "sync_preference_unavailable": "Ya tienes las preferencias predeterminadas",
    "template": "Plantilla",
    "template_and_import": "Plantilla e importación",
    "text_max_length_255": "El texto debe tener como máximo 255 caracteres",
    "text_max_length_3000": "El texto debe tener como máximo 3000 caracteres",
    "text_min_length_1": "El texto debe tener al menos 1 carácter",
    "text_min_length_3": "El texto debe tener al menos 3 caracteres",
    "this_action_cannot_be_undone": "Esta acción no se puede deshacer.",
    "time_format_expected": "Formato de hora inválido",
    "Time_invalid": "La hora es inválida",
    "title_initiative_data": "Datos de la iniciativa",
    "too_many_requests_wait": "Demasiadas solicitudes. Espere unos instantes e inténtelo de nuevo.",
    "totp_error": "Código inválido",
    "totp_instruction": "Inserte el código de autentificación",
    "trigger": "Disparador",
    "trigger_type": "Tipo de disparador",
    "trigger_type_required": "El tipo de disparador es obligatorio",
    "type": "Tipo",
    "type_required": "El tipo es obligatorio",
    "update": "Actualizar",
    "update_version": "Subir versión",
    "update_version_confirm_description": "¿Está seguro de que desea subir la versión de la funcionalidad? Esta acción puede agregar nuevas validaciones o eliminar campos previamente registrados.",
    "updated_at_label": "Modificado {{date}}",
    "upload": "Subir",
    "user": "Usuario",
    "user_added_successfully": "Usuario agregado con éxito.",
    "user_created_successfully": "Usuario creado con éxito.",
    "user_data": "Datos del usuario",
    "user_edited_successfully": "Usuario editado con éxito.",
    "user_preference": "Cambiar a preferencias predeterminadas",
    "user_profile": "Perfil del usuario",
    "user_removed_from_group_successfully": "Usuario eliminado del grupo con éxito.",
    "user_required": "El usuario es obligatorio",
    "user_status": "Estado del usuario",
    "users": "Usuarios",
    "users_found": "No se encontraron usuarios",
    "valid_link_required": "Es necesario indicar un enlace válido",
    "valid_powerbi_link_required": "Es necesario indicar un enlace válido de Power BI",
    "value": "Valor",
    "value_must_be_a_number": "El valor debe ser un número",
    "value_required": "El valor es obligatorio",
    "version": "Versión",
    "video_tag_not_supported": "Visualización de video no soportada",
    "view": "Visualización",
    "view_analytics": "Ver estadísticas",
    "view_version": "Ver versión",
    "view_workflow": "Visualizar workflow",
    "visualizer_error": "Error al mostrar el visualizador de audio",
    "waiting": "Esperando",
    "waveform_error": "Error al generar la forma de onda del audio",
    "web": "Web",
    "workflow_deleted_successfully": "Workflow eliminado con éxito",
    "workflows": "Workflows",
    "yes": "Sí",
    "you_can_create_link": "Puede crear un enlace público para recopilar respuestas en línea."
  },
  "initiative": {},
  "features": {},
  "translation": {}
} as const;
